import {Box, Typography} from '@mui/material';

import {orangeColors, neutral} from '../../../../../../layouts/theme/designSystem';

interface Props {
  message: string;
}

export const CultureAnalysisEmptyState = ({message}: Props) => (
  <Box
    sx={{
      backgroundColor: orangeColors[7],
      border: `1px solid ${orangeColors[3]}`,
      borderRadius: '8px',
      padding: '1.5rem',
      width: '100%',
    }}
  >
    <Typography
      sx={{
        color: neutral[500],
        fontSize: '14px',
        lineHeight: 1.5,
        textAlign: 'center',
      }}
    >
      {message}
    </Typography>
  </Box>
);
